import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'contentTypeButton', 'contentTypeInput',
    'templateSection', 'dynamicRecommendationsSection', 'optInSection'
  ]

  static values = { contentType: String }

  connect() {
    this.applyContentType()
  }

  contentTypeClicked(event) {
    event?.preventDefault()
    const nextType = event.currentTarget.dataset.contentTypeValue
    if (!nextType || nextType === this.contentTypeValue) return
    this.contentTypeValue = nextType
    if (this.hasContentTypeInputTarget) this.contentTypeInputTarget.value = nextType
    this.applyContentType()
  }

  applyContentType() {
    const current = this.contentTypeValue

    this.contentTypeButtonTargets.forEach((btn) => {
      const selected = btn.dataset.contentTypeValue === current
      btn.classList.toggle('bg-white', selected)
      btn.classList.toggle('text-gray-900', selected)
      btn.classList.toggle('shadow-sm', selected)
      btn.classList.toggle('border', selected)
      btn.classList.toggle('border-gray-200', selected)
      btn.classList.toggle('text-gray-600', !selected)
      btn.classList.toggle('hover:text-gray-900', !selected)
      btn.classList.toggle('cursor-pointer', !selected)
    })

    if (this.hasTemplateSectionTarget) {
      this.templateSectionTarget.classList.toggle('hidden', current !== 'template')
    }
    if (this.hasDynamicRecommendationsSectionTarget) {
      this.dynamicRecommendationsSectionTarget.classList.toggle('hidden', current !== 'dynamic_recommendations')
    }
    if (this.hasOptInSectionTarget) {
      this.optInSectionTarget.classList.toggle('hidden', current !== 'opt_in')
    }
  }
}
